<template>
  <label :class="{'disabled': disabled}">
    <input
      type="checkbox"
      role="checkbox"
      class="visually-hidden"
      :aria-checked="checked"
      :checked="checked"
      @click="$emit('update:checked', !checked, $event)"
      :disabled="disabled"
    />
    <i-icon
      :icon="checked ? 'check-square': 'square'"
      :type="checked ? 'fas': 'far'"
      class="fa5"
      @click.prevent="$emit('update:checked', !checked, $event)"
      @keydown.space.prevent="$emit('update:checked', !checked, $event)"
    />
    <slot />
  </label>
</template>

<script>
import { defineComponent } from 'vue';
import Icon from '../icon/Icon.vue';

export default defineComponent({
  name: 'i-checkbox',
  components: {
    [Icon.name]: Icon,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped lang='scss'>
i {
  font-size: 18px;
  padding: 5px 8px;
  margin: 0;
  transition: color 0.2s;

  &.fa-square {
    color: rgba(28, 56, 95, 0.6);
  }
  &:hover.fa-square {
    color: #1C385F;
  }

  &.fa-check-square {
    color: #1c385f;
  }
}
// TODO: use `useFocusVisible` hook/composable instead of the pseudo CSS class
// draw focus ring around the icon when the input is focused
input:focus-visible + i {
  outline-style: solid;
  outline-color: $orange;
  outline-width: 3px;
  outline-offset: -3px;
}
.visually-hidden {
  border: 0px;
  clip: rect(0px, 0px, 0px, 0px);
  clip-path: inset(50%);
  height: 1px;
  margin: 0px -1px -1px 0px;
  overflow: hidden;
  padding: 0px;
  position: absolute;
  width: 1px;
  white-space: nowrap;
}
label {
  user-select: none;
  // reset global styles in production:
  // FIXME: remove once we get rid of the global stylesheet
  margin-bottom: 0;

  &.disabled {
    pointer-events: none;
    opacity: 0.65;
  }
}
</style>
